import { Component, OnDestroy, OnInit, } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import {LiveAnnouncer} from '@angular/cdk/a11y';
import {MatSort, Sort} from '@angular/material/sort';
import {AfterViewInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';

import { CashierTransactionsService } from './cashier-transactions.service';
import { TellerGlobalServiceService } from 'app/shared/teller-data/teller-global-service.service';
import { Observable, Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { DialogHelper } from 'app/core/utils/dialog-helper';
import { OTPRequestData } from 'app/model/tillotp';

@Component({
  selector: "mifosx-cashier-transactions",
  templateUrl: "./cashier-transactions.component.html",
  styleUrls: ["./cashier-transactions.component.scss"],
})
export class CashierTransactionsComponent implements OnInit, AfterViewInit, OnDestroy {
  htmlForm: FormGroup;
  minDate = new Date(2000, 0, 1);
  maxDate = new Date();
  selectedTeller: any;
  transactionList: Array<any> = []
  cashierTransactionsList: any = [];
  columnsToDisplay = ["txnTime", "txnTypeName", "causal", "txnAmount", "currencyAcronym", "action"];

  txnDateFrom = new Date();
  txnDateTo = new Date();

  tellerSub: Subscription;

  /** Handle transaction approval */
  approvalDialogRef: Observable<any>;
  approvalData = {};

  constructor(
    private formBuilder: FormBuilder,
    private cashierTransactionsService: CashierTransactionsService,
    private router: Router,
    private tellerGlobalService: TellerGlobalServiceService,
    private _liveAnnouncer: LiveAnnouncer,
    private matDialog: MatDialog,
    private dialogHelper: DialogHelper
  ) {}

  @ViewChild(MatSort) sort: MatSort;

  ngOnInit(): void {
    this.tellerSub = this.tellerGlobalService.getSelectedTeller$().subscribe((data) => (this.selectedTeller = data));

    this.htmlForm = this.formBuilder.group({
      txnDateFrom: [new Date(), Validators.required],
      txnDateTo: [new Date(), Validators.required],
    });

    this.applyFilter();
  }

  ngAfterViewInit(): void {
    this.cashierTransactionsList.sort = this.sort;
  }

  ngOnDestroy(): void {
    if (this.tellerSub) {
      this.tellerSub.unsubscribe();
    }
  }
  /** Announce the change in sort state for assistive technology. */
  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce("Sorting cleared");
    }
  }

  applyFilter() {
    this.cashierTransactionsService
      .adjustCashDifferences(
        this.selectedTeller["id"],
        this.getDBDateFormat(this.htmlForm.controls["txnDateFrom"].value),
        this.getDBDateFormat(this.htmlForm.controls["txnDateTo"].value),
        "{}"
      )
      .subscribe((res: any[]) => {
        this.cashierTransactionsList = new MatTableDataSource(res);
        this.cashierTransactionsList.sort = this.sort;
      });
  }

  getDBDateFormat(currDate: Date) {
    var tzoffset = (new Date()).getTimezoneOffset() * 60000;
    var localISOTime = (new Date(currDate.getTime() - tzoffset)).toISOString().slice(0, -1);
    return localISOTime.slice(0, -6).split("T")[0];
  }

  submit() {
    const data = {
      /*
        "adjustmentType": this.cashDifferenceForm.value.transactionType,
        "currencyCode": this.cashDifferenceForm.value.currencyCode,
        "txnAmount": this.cashDifferenceForm.value.amount,
        "locale": this.settingsService.language.code,
        "txnDate": this.dateUtils.formatDate(this.cashDifferenceForm.value.txnDate, this.settingsService.dateFormat),
        "dateFormat": this.settingsService.dateFormat
        */
    };
    /*
    this.cashDifferenceService.adjustCashDifferences(this.selectedTeller['id'], data).subscribe(res => {
        this.router.navigate(['/home'], { relativeTo: this.route });
    });
*/
  }

  revertTransaction(transactionObj: string) {
    //  alert('Reverting ' + transactionId + ' with origin ' + origin);

    const transactionId = transactionObj["transactionId"]
    const origin = transactionObj["origin"];
    const entityId = transactionObj["entityId"];
    const amount = transactionObj["txnAmount"];
    const currencyCode = transactionObj["currencyAcronym"];
    const teller = this.selectedTeller["id"];

    const transactionData = {
      origin: origin,
      entityId: entityId,
      tellerId: teller,
      transactionId: transactionId,
      amount: 0,  // Only useful for approval process, actual amount taken from transaction
      currencyCode: currencyCode,
      ...this.approvalData,
    };

    this.approvalData = {};
    this.cashierTransactionsService
      .undoTransacion(teller, transactionId, transactionData)
      .subscribe((res) => {
        if (
          res.hasOwnProperty("httpStatusCode") &&
          res.httpStatusCode === "202" &&
          res.userMessageGlobalisationCode == "response.msg.approval.required"
        ) {
          const otpRequestData: OTPRequestData = {
            requestAmount: 0,
            entityId: entityId,
            title: `Approve Reversal of ${amount} ${currencyCode}`,
          };

          this.approvalDialogRef = this.dialogHelper.showApprovalDialog(otpRequestData, this.matDialog).afterClosed();
          this.approvalDialogRef.subscribe((result) => {
            if (result && result.hasOwnProperty("approvalToken")) {
              this.approvalData = result;
              this.revertTransaction(transactionObj);
            }
          });
        } else {
          this.reloadCurrentRoute();
        }
      });
  }

  reloadCurrentRoute() {
    let currentUrl = this.router.url;
    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }
}
